module.exports = __webpack_public_path__ + "static/colgadas-014.thumb-6f2ec7f380170687bbf1a66a23838ef3.jpg";